module.exports = __webpack_public_path__ + "media/images/front/brands/signature/signature_3-b0245bd23593b45842b808a428615d22.webp";